window.showGDPR = function () {
    const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith('COOKIES_CONSENT='));

    // Ne pas afficher le popup si un choix a déjà été enregistré
    if(cookieValue != undefined){
        var consent = cookieValue.split('=')[1];
        if(consent === 'true' || consent === 'false'){
            return;
        }
    }

    const body = $("body");
    body.append(gdprPopupHTML);
    
    initButtonsPopup();
}

const initButtonsPopup = function() {
    const body = $("body");
    
    var btnYes = $(body).find(".action-enable-cookies");
    var btnNo = $(body).find(".action-disable-cookies");
    
    btnYes.on("click",function(e) {
        e.preventDefault();
        detruirePopupGDPR();    
        enableCookies();
    });
    
    btnNo.on("click",function(e) {
        e.preventDefault();
        detruirePopupGDPR();
        disableCookies();
    });
}

window.initButtonsOptionsPage = function() {
    const body = $("body");
    
    var btnYes = $(body).find(".action-enable-cookies");
    var btnNo = $(body).find(".action-disable-cookies");

    const cookieValue = document.cookie
    .split('; ')
    .find(row => row.startsWith('COOKIES_CONSENT='));

    if(cookieValue != undefined){
        var consent = cookieValue.split('=')[1];
        if(consent === 'true'){
            btnYes.addClass('active');
        } else if (consent === 'false'){
            btnNo.addClass('active');
        }
    }
    
    
    btnYes.on("click",function(e) {
        e.preventDefault();
        btnYes.addClass('active');
        btnNo.removeClass('active');
        enableCookies();
        redirectAfterChoice();
    });
    
    btnNo.on("click",function(e) {
        e.preventDefault();
        btnNo.addClass('active');
        btnYes.removeClass('active');
        disableCookies();
        redirectAfterChoice();
    });
}

const detruirePopupGDPR = function () {
    var gdprPopup = $(".gdprpopup");
    gdprPopup.remove();
}

const enableCookies = function () {
    document.cookie = `COOKIES_CONSENT=true;expires=${new Date(new Date().getTime()+31536000000).toGMTString()};path=/`; // 1000*60*60*24*365 = 31536000000 donc 365 jours
}

const disableCookies = function () {
    document.cookie = `COOKIES_CONSENT=false;expires=${new Date(new Date().getTime()+7862400000).toGMTString()};path=/`; // 1000*60*60*24*91 = 7862400000. 91 correspond a 1/4 de 365 donc environ 3 mois
}

const redirectAfterChoice = function () {
    if(typeof window.redirectTarget !== 'undefined'){
        window.location.replace(window.redirectTarget);
    } else {
        history.back();
    }
}